import moment from "moment";

import { Button, Modal, Table, Typography } from "antd";

import { formatDate, formatPhoneNumber, formatZipCode, getDisplayCompanyId } from "utils/helpers";

import PcpDetailModalProps from './Proptypes';
import { ORGANIZATION_NAME } from "utils/objects";

const { Title } = Typography;

const PcpDetailModal = (props: PcpDetailModalProps) => {
  const pcpDetailColumns = [
    {
      title: "STREET",
      key: "RmiStreet",
      dataIndex: "RmiStreet",
    },
    {
      title: "CITY",
      key: "RmiCity",
      dataIndex: "RmiCity",
    },
    {
      title: "STATE",
      key: "RmiState",
      dataIndex: "RmiState",
    },
    {
      title: "ZIP",
      key: "RmiZip",
      dataIndex: "RmiZip",
      render: (_: number, record: any) => formatZipCode(record.RmiZip)
    },
    {
      title: "COUNTRY",
      key: "RmiCountry",
      dataIndex: "RmiCountry",
    },
    {
      title: "PHONE",
      key: "RmiPhone",
      dataIndex: "RmiPhone",
      render: (_: number, record: any) => formatPhoneNumber(record.RmiPhone)
    },
    {
      title: "FAX",
      key: "RmiFax",
      dataIndex: "RmiFax",
      render: (_: number, record: any) => formatPhoneNumber(record.RmiFax)
    },
    {
      title: "OFFICE TYPE",
      key: "RmiType",
      dataIndex: "RmiType",
    },
  ];

  return (
    <>
      <Modal
        visible={props.isPcpDetailModalVisible}
        width="1300px"
        maskClosable={false}
        onCancel={props.pcpDetailModalCloseHandler}
        footer={[
          <>
            <div className="row pt-2">
              <div className="col-lg-12 col-md-12">
                <p className="float-left pt-2">&copy; {ORGANIZATION_NAME}, Inc., All Rights Reserved</p>
              </div>
            </div>
          </>,
        ]}
      >
        <div className="container">
          <Title level={4}>PCP Detail</Title>
        </div>

        <hr />

        <div className="row flex-lg-wrap justify-content-start mb-4 ml-0">
          <div className="col-lg-12 col-md-12">
            <table className="test" style={{ textAlign: "left" }}>
              <tbody>
                <tr>
                  <th className="bold">Provider ID:</th>
                  <td>{props.primaryCareProvider.RmiProvId}</td>
                </tr>
                <tr>
                  <th className="bold">Name:</th>
                  <td>{props.primaryCareProvider.RmiRevFullName}</td>
                </tr>
                <tr>
                  <th className="bold">Address:</th>
                  <td>{props.primaryCareProvider.RmiStreet}</td>
                </tr>
                {props.primaryCareProvider.RmiStreet2 &&
                  <tr>
                    <th className="bold">Address 2:</th>
                    <td>{props.primaryCareProvider.RmiStreet2}</td>
                  </tr>
                }
                <tr>
                  <th className="bold">City, State, Zip:</th>
                  <td>
                    {props.primaryCareProvider.RmiCity}{props.primaryCareProvider.RmiStreet ? ',' : ''} {props.primaryCareProvider.RmiState} {formatZipCode(props.primaryCareProvider.RmiZip)}
                  </td>
                </tr>
                <tr>
                  <th className="bold">Practice Group:</th>
                  <td></td> {/* Legacy code commented out the data, but shows Practice Group: title */}
                </tr>
                <tr>
                  <th className="bold">Specialty:</th>
                  <td>{props.primaryCareProvider.RmiProvSpecialties}</td>
                </tr>
                <tr>
                  <th className="bold">Phone #:</th>
                  <td>{formatPhoneNumber(props.primaryCareProvider.RmiPhone)}</td>
                </tr>
                <tr>
                  <th className="bold">Fax #:</th>
                  <td>{formatPhoneNumber(props.primaryCareProvider.RmiFax)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lg-12 col-md-12">
            <table className="test" style={{ textAlign: "left" }}>
              <tbody>
                <tr>
                  <th className="bold">Company ID:</th>
                  <td>{getDisplayCompanyId(props.primaryCareProvider.RmiCompanyId)}</td>
                </tr>
                <tr>
                  <th className="bold">Class:</th>
                  <td>{props.primaryCareProvider.RmiClass}</td>
                </tr>
                <tr>
                  <th className="bold">Group ID:</th>
                  <td></td> {/* legacy code commented out the data, but shows the Group ID: title */}
                </tr>
                <tr>
                  <th className="bold">PCP Effect Date:</th>
                  <td>{moment(props.primaryCareProvider.RmiFromDate).format("MM/DD/YYYY")}</td>
                </tr>
                <tr>
                  <th className="bold">PCP Termination:</th>
                  <td>{formatDate(props.primaryCareProvider.RmiTermDate, 'MM/DD/YYYY')}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <hr />

        <Title level={5}>
          Office Locations
        </Title>
        <Table
          columns={pcpDetailColumns}
          dataSource={props.primaryCareProvider.ProviderOffices}
          pagination={{ position: ["bottomCenter"],  hideOnSinglePage: true }}
        />
      </Modal>
    </>
  );
};

export default PcpDetailModal;
